import { Component, OnInit } from '@angular/core';
import { ForAllService } from "../for-all.service";

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  idiomas: any;
  preguntas: any[] = [];
  nombreEmpresa: string;
  nombreIdioma: string;
  cargando = true;

  constructor(
    private forallService: ForAllService,
  ) { }

  ngOnInit() {
    this.getIdiomas();
  }

  getIdiomas(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    };
    this.forallService.getIdiomasPreview(data).subscribe((respuesta:any) => {
      this.idiomas = respuesta.idiomasMostrar;
      this.cargando = false;
    }, error => {
      console.log("error", error);
    });
  }

  cambiaIdioma(event){
    this.nombreIdioma = event.value.nombreIdioma;
    this.cargando = true;
    if(event.value.tipoIdioma == 1){
      this.getNativo();
    }else{
      this.getTraduccion(event.value.nombreIdioma, event.value._id);
    }
  }

  getNativo(){
    let data = {fechaCertificar: localStorage.getItem('fechaProducto')};
    this.forallService.getParams(data).subscribe((respuesta:any) => {
      this.nombreEmpresa = respuesta.empresa;
      var splittedNueva = respuesta.objeto.statement2Nativo.split("?");
      var nombreEmpresa = respuesta.empresa;
      var splitted1 = respuesta.objeto.statement1Nativo.split("$replace1");
      // var splitted2 = respuesta.objeto.statement2Nativo.split("$replace1");
      var splitted2 = splittedNueva[0].split("$replace1");
      console.log('splittedNueva',splittedNueva);
      console.log('splitted2',splitted2);
      // console.log('splittedNuevaFinal',splittedNuevaFinal);


      this.forallService.getPracticas(data).subscribe((respuesta2:any) => {
        this.preguntas = [];
        respuesta2.practicas.forEach((practica,i) => {
          this.preguntas.push(
            {
              orden: i,
              practicaForall: practica.practicaForall,
              statement1: '',
              statement2: '',
              _id: practica._id,
              statement1Part1: splitted1[0],
              statement1Part2: splitted1[1],
              statement2Part1: splitted2[0],
              statement2Part2: splitted2[1].replace("$replace2",""),
              description: practica.descripcionForall
            }
          );
        });
        this.cargando = false;
      }, error => {
        console.log("error", error);
      });
    }, error => {
      console.log("error", error);
    });
  }

  getTraduccion(nombreIdioma:string, idIdioma:string){
    let data = {
      clave: nombreIdioma,
      fechaCertificar: localStorage.getItem('fechaProducto'),
      idiomaId: idIdioma
    };
    this.forallService.getParams(data).subscribe((respuesta:any) => {
      this.preguntas = [];
      for (let i = 0; i < respuesta.objeto.idForall.length; i++) {
        this.nombreEmpresa = respuesta.empresa;
        var splittedNueva = respuesta.objeto.statement2.split("?");
        var splitted1 = respuesta.objeto.statement1.split("$replace1");
        // var splitted2 = respuesta.objeto.statement2.split("$replace1");
        var splitted2 = splittedNueva[0].split("$replace1");
        this.preguntas.push(
          {
            orden: i,
            practicaForall: respuesta.objeto.idForall[i].practicaForall,
            statement1: respuesta.objeto.statement1.replace('$replace1',respuesta.objeto.idForall[i].practicaForall),
            statement2: respuesta.objeto.statement2.replace('$replace1',respuesta.objeto.idForall[i].practicaForall).replace('$replace2',respuesta.empresa),
            _id: respuesta.objeto.idForall[i].idForall,
            statement1Part1: splitted1[0],
            statement1Part2: splitted1[1],
            statement2Part1: splitted2[0],
            statement2Part2: splitted2[1].replace("$replace2",""),
            description: respuesta.objeto.idForall[i].descripcionForall
          }
        );
      }
      this.cargando = false;
    }, error => {
      console.log("error", error);
    });
  }
}
